export default function ProjectTimeline () {

  let projectTimeline = document.getElementById('project-timeline');

  const fn = {
      init: function () {

        const currentItems = projectTimeline.getElementsByClassName('chevron-progress__step current');
        const phaseMarker = document.getElementsByClassName('current-phase-marker')[0];

        if (!currentItems.length) {
          phaseMarker.style.setProperty('display', 'none');
        } else {

          let arrowOffset = 0;
          let currentStart = 0;
          let currentLength = 0;

          if ( window.innerWidth > 1150){

            arrowOffset = document.getElementsByClassName('chevron-progress__arrow')[0].offsetWidth;
            currentStart = currentItems[0].offsetLeft - arrowOffset;
    
            if (currentItems.length === 1) {
              currentLength = currentItems[0].offsetWidth;
            } else {
              Array.from(currentItems).forEach(item => {
                currentLength += item.offsetWidth;
              });
            }

            phaseMarker.style.setProperty('--horizontal-offset', `${currentStart}px`);
            phaseMarker.style.setProperty('--marker-width', `${currentLength}px`);

          } else {

            arrowOffset = document.getElementsByClassName('chevron-progress__arrow')[0].offsetHeight;
            currentStart = currentItems[0].offsetTop - arrowOffset;

            if (currentItems.length === 1) {
              currentLength = currentItems[0].offsetHeight;
            } else {
              Array.from(currentItems).forEach(item => {
                currentLength += item.offsetHeight;
              });
            }
            phaseMarker.style.setProperty('--vertical-offset', `${currentStart}px`);
            phaseMarker.style.setProperty('--marker-height', `${currentLength}px`);
          }
          
        
      }

    }

  };

  if (projectTimeline) {
    fn.init();   
  }
}